import { markInputRule, markPasteRule } from '@tiptap/core';
import { Italic } from '@tiptap/extension-italic';

/* Regexes are slightly modified versions from the original ones in the @tiptap/extension-italic package. */

/**
 * Matches an italic to a *italic* on input. Does not allow whitespace at the start or end of the text.
 */
const starInputRegexNoWhitespaceAtStartOrEnd = /(?:^|\s)(\*([^*\s][^*]*[^*\s]|[^*\s])\*)$/;

/**
 * Matches an italic to a *italic* on paste. Does not allow whitespace at the start or end of the text.
 */
const starPasteRegexNoWhitespaceAtStartOrEnd = /(?:^|\s)(\*([^*\s][^*]*[^*\s]|[^*\s])\*)/g;

/**
 * Matches an italic to a _italic_ on input. Does not allow whitespace at the start or end of the text.
 */
const underscoreInputRegexNoWhitespaceAtStartOrEnd = /(?:^|\s)(_([^\s_][^_]*[^\s_]|[^\s_])_)$/;

/**
 * Matches an italic to a _italic_ on paste. Does not allow whitespace at the start or end of the text.
 */
const underscorePasteRegexNoWhitespaceAtStartOrEnd = /(?:^|\s)(_([^\s_][^_]*[^\s_]|[^\s_])_)/g;

export const ZyItalic = Italic.extend({
    addInputRules() {
        return [
            markInputRule({
                find: starInputRegexNoWhitespaceAtStartOrEnd,
                type: this.type,
            }),
            markInputRule({
                find: underscoreInputRegexNoWhitespaceAtStartOrEnd,
                type: this.type,
            }),
        ];
    },

    addPasteRules() {
        return [
            markPasteRule({
                find: starPasteRegexNoWhitespaceAtStartOrEnd,
                type: this.type,
            }),
            markPasteRule({
                find: underscorePasteRegexNoWhitespaceAtStartOrEnd,
                type: this.type,
            }),
        ];
    },
});
